/**
 * @description 数据类型枚举
 */
export enum Types {
  Object = 'object',
  Array = 'array',
  String = 'string',
  Number = 'number',
  Function = 'function',
  Undefined = 'undefined',
  Null = 'null',
  Symbol = 'symbol',
  BigInt = 'bigInt',
  Map = 'map',
  Set = 'set',
  ReadableStream = 'readableStream',
  FileReader = 'fileReader',
  Blob = 'blob',
  HTMLDocument = 'HTMLDocument',
  Window = 'window',
  Request = 'request',
  Response = 'response',
  Unknown = 'unknown',
}

export interface NumberAndUnitType {
  number: number;
  unit: string;
}
